import { useState } from 'react'
import axios from 'axios'
import { authHeaders } from '../CuentaCompensacion'
import styles from './DIMDataViewer.module.css'

const API = import.meta.env.VITE_API_GATEWAY_URL

const CAMPOS_DIM = [
    { key: 'prefijo_factura',       label: 'Prefijo Factura',   hint: 'Prefijo alfa antes del número de factura' },
    { key: 'casilla_51_factura',    label: 'Casilla 51 — N° Factura', hint: 'Número de la factura comercial' },
    { key: 'casilla_46_proveedor',  label: 'Casilla 46 — Proveedor',  hint: 'Nombre del exportador / proveedor' },
    { key: 'casilla_58_trm',        label: 'Casilla 58 — TRM',        hint: 'Tasa Representativa del Mercado ($ COP / 1 USD)' },
    { key: 'casilla_78_valor_fob_usd', label: 'Casilla 78 — Valor FOB (USD)', hint: 'Valor FOB en dólares' },
    { key: 'casilla_94_arancel',    label: 'Casilla 94 — Arancel ($)',  hint: 'Total arancel liquidado en pesos' },
    { key: 'casilla_99_iva',        label: 'Casilla 99 — IVA ($)',      hint: 'Total IVA liquidado en pesos' },
    { key: 'casilla_133_fecha_dim', label: 'Casilla 133 — Fecha DIM',   hint: 'Fecha de aceptación de la declaración (YYYY-MM-DD)' },
]

function DIMDataViewer({ decl, onSave, onClose, setMsg }) {
    const [extracting, setExtracting] = useState(false)
    const [campos, setCampos] = useState(
        decl.dim_datos && Object.keys(decl.dim_datos).length > 0
            ? { ...decl.dim_datos }
            : null
    )

    const handleExtract = async () => {
        if (!decl.documento_s3_key) {
            setMsg({ type: 'error', text: 'Esta declaración no tiene un documento PDF adjunto' })
            return
        }
        setExtracting(true)
        try {
            const headers = await authHeaders()
            const res = await axios.post(`${API}/dim-parser`, { s3_key: decl.documento_s3_key }, { headers })
            if (res.data.success) {
                setCampos(res.data.fields || {})
                setMsg({ type: 'success', text: 'Campos DIM extraídos exitosamente. Revisa y guarda.' })
            } else {
                setMsg({ type: 'error', text: res.data.error || 'No se pudieron extraer campos' })
            }
        } catch (err) {
            setMsg({ type: 'error', text: 'Error extrayendo DIM: ' + (err.response?.data?.error || err.message) })
        } finally {
            setExtracting(false)
        }
    }

    const handleChange = (key, value) => {
        setCampos(prev => ({ ...prev, [key]: value }))
    }

    const handleSave = () => {
        if (!campos) { setMsg({ type: 'error', text: 'Primero extrae los datos del PDF' }); return }
        onSave(campos)
    }

    return (
        <div className={styles.viewer}>
            <div className={styles.viewerHeader}>
                <span className={styles.viewerTitle}>Extracción de Datos DIM</span>
                <button className={styles.btnClose} onClick={onClose}>✕</button>
            </div>

            <p className={styles.desc}>
                Extrae automáticamente los campos reglamentarios de la Declaración de Importación de Mercancías (DIM).
                Revisa y corrige los valores antes de guardar.
            </p>

            {/* Botón extraer */}
            {!campos && (
                <button
                    className={styles.btnExtract}
                    onClick={handleExtract}
                    disabled={extracting}
                >
                    {extracting ? (
                        <><span className={styles.spinner}></span> Analizando PDF…</>
                    ) : (
                        '🔍 Extraer campos del PDF'
                    )}
                </button>
            )}

            {campos !== null && (
                <>
                    <div className={styles.grid}>
                        {CAMPOS_DIM.map(campo => (
                            <div key={campo.key} className={styles.campoRow}>
                                <div className={styles.campoLabel}>
                                    <span>{campo.label}</span>
                                    <small>{campo.hint}</small>
                                </div>
                                <input
                                    className={`${styles.campoInput} ${campos[campo.key] ? styles.campoFilled : styles.campoEmpty}`}
                                    value={campos[campo.key] || ''}
                                    onChange={e => handleChange(campo.key, e.target.value)}
                                    placeholder={campos[campo.key] ? '' : 'No encontrado — ingresa manualmente'}
                                />
                            </div>
                        ))}
                    </div>

                    <div className={styles.viewerActions}>
                        <button
                            className={styles.btnReExtract}
                            onClick={handleExtract}
                            disabled={extracting}
                        >
                            {extracting ? 'Extrayendo…' : '↺ Re-extraer'}
                        </button>
                        <button className={styles.btnSave} onClick={handleSave}>
                            💾 Guardar datos DIM
                        </button>
                    </div>
                </>
            )}
        </div>
    )
}

export default DIMDataViewer
